export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7912.6a2caf43.jpg";